import { selectorObj } from '@/components';
import { optOutOptions } from '@/globalConsts';

export const formatOptOutReason = (opt_out_reason: string) => {
	const optOutOption = optOutOptions.find((option) => option.value === opt_out_reason);
	return optOutOption ? optOutOption.label : opt_out_reason;
};

// This function is used to generate the options for the select fields in the filters form based on the data returned from the API.
// it takes in the data returned from the API request (formatted for the selector with nested items) and the type of filter and
// returns an array of options in the format of { label: string, value: string OR { name: string, id: string } } which is used by the select fields in the filters form.

export const generateStudySiteSelectOptions = (
	studySitesResults: selectorObj[],
	returnValueAsObject = true
) => {
	const studySiteSelectOptions = studySitesResults?.map((study) => {
		return {
			label: study.parentItem.name,
			options: study.nestedItems.map((nestedItem) => {
				return {
					label: nestedItem.name,
					value: returnValueAsObject
						? { name: nestedItem.name, id: nestedItem.id }
						: (nestedItem.id ?? ('' as string)),
				};
			}),
		};
	});
	return studySiteSelectOptions;
};
